import { twClassMerge } from '@healthhub/react-ui';

interface CarouselDotsProps {
  active: boolean;
  onClick: () => void;
}

const CarouselDots = ({ active, onClick }: CarouselDotsProps) => (
  <button
    aria-label="dot"
    className={twClassMerge(
      'size-2 rounded-full bg-[#bdbdbd] transition-colors duration-100 ease-in-out',
      active && 'bg-primary-blue-grey-4'
    )}
    onClick={onClick}
  />
);

export default CarouselDots;
